// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEmailAttention_root__4kUPP","marketplaceStroke":"IconEmailAttention_marketplaceStroke__3meIs","attentionStroke":"IconEmailAttention_attentionStroke__1YrRb"};